export const BG = "#070B14";
export const BLUE = "#4285F4";
export const ORANGE = "#FBBC04";
export const GREEN = "#34A853";
export const RED = "#EA4335";
export const BURNT = "#EA580C";
export const BURNT_GLOW = "#FB923C";

export const glass: React.CSSProperties = {
  background: "linear-gradient(160deg, rgba(15,22,38,0.78), rgba(8,12,22,0.85))",
  border: "1px solid rgba(255,255,255,0.08)",
  backdropFilter: "blur(14px)",
  boxShadow:
    "0 1px 0 rgba(255,255,255,0.04) inset, 0 24px 60px -30px rgba(0,0,0,0.6)",
};

export type AriaTrigger = {
  prompt: string;
  context?: Record<string, any>;
  forceAdvanced?: boolean;
} | null;
